import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import { ReactComponent as LoveColoredSvg } from './assets/love-colored.svg';

const LoveColoredIcon = React.forwardRef((args, ref) => <SvgIcon component={LoveColoredSvg} ref={ref} {...args} />);

export default LoveColoredIcon;
